(function () {
  const SECTION_DRAWER = "api--cart-drawer";
  const SECTION_MINI_CART = "api--product-feed--mini-cart";
  const SECTION_BUBBLE = "api--header--cart-bubble";
  const SECTION_DISCOUNT = "api--cart--discount";

  function getDrawer() {
    return document.getElementById("cart-drawer");
  }

  function getSectionIds() {
    const ids = new Set([
      SECTION_DRAWER,
      SECTION_MINI_CART,
      SECTION_BUBBLE,
      SECTION_DISCOUNT,
    ]);
    document.querySelectorAll("cart-dynamic[data-section-id]").forEach((node) => {
      if (node.dataset.sectionId) ids.add(node.dataset.sectionId);
    });
    document.querySelectorAll("cart-discount[data-section-id]").forEach((node) => {
      if (node.dataset.sectionId) ids.add(node.dataset.sectionId);
    });
    return [...ids];
  }

  async function refreshCartSections() {
    const sectionIds = getSectionIds();
    if (!sectionIds.length) return null;

    const root = window.Shopify?.routes?.root || "/";
    const response = await fetch(`${root}?sections=${sectionIds.join(",")}`);
    if (!response.ok) return null;

    const sections = await response.json();

    document.querySelectorAll("cart-dynamic[data-section-id]").forEach((node) => {
      const htmlString = sections[node.dataset.sectionId];
      if (!htmlString) return;

      const html = new DOMParser().parseFromString(htmlString, "text/html");
      const fresh = html.querySelector(
        `cart-dynamic[data-section-id='${node.dataset.sectionId}']`
      );
      if (!fresh) return;

      node.innerHTML = fresh.innerHTML;
      node.className = fresh.className;
      node.dataset.cartItemCount = fresh.dataset.cartItemCount;
      node.dataset.cartTotal = fresh.dataset.cartTotal;
      node.dataset.freeShippingThreshold = fresh.dataset.freeShippingThreshold;
      if (typeof node.modified === "function") node.modified();
    });

    document.querySelectorAll("cart-discount[data-section-id]").forEach((node) => {
      const htmlString = sections[node.dataset.sectionId];
      if (!htmlString) return;

      const html = new DOMParser().parseFromString(htmlString, "text/html");
      const fresh = html.querySelector("cart-discount");
      if (!fresh) return;

      node.replaceWith(fresh);
    });

    updateDrawerChrome(sections);
    return sections;
  }

  function updateDrawerChrome() {
    const feed = document.querySelector(
      `cart-dynamic[data-section-id='${SECTION_DRAWER}']`
    );
    updateShippingBar(feed);
  }

  function updateShippingBar(feed) {
    if (!feed) return;

    const bar = getDrawer()?.querySelector("[data-cart-drawer-shipping]");
    if (!bar) return;

    const threshold = parseInt(feed.dataset.freeShippingThreshold || "0", 10);
    const total = parseInt(feed.dataset.cartTotal || "0", 10);
    if (threshold <= 0) return;

    const remaining = Math.max(threshold - total, 0);
    const percent = Math.min(Math.round((total / threshold) * 100), 100);

    const fill = bar.querySelector("[data-cart-drawer-shipping-fill]");
    const text = bar.querySelector("[data-cart-drawer-shipping-text]");
    if (fill) fill.style.width = `${percent}%`;

    if (text && window.cartDrawerStrings) {
      text.textContent =
        remaining === 0
          ? window.cartDrawerStrings.freeShippingReached
          : window.cartDrawerStrings.freeShippingRemaining.replace(
              "__AMOUNT__",
              formatMoney(remaining)
            );
    }
  }

  function formatMoney(cents) {
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(2);
  }

  async function removeLineItem(button) {
    const line = button.dataset.line;
    if (!line) return;

    const config =
      typeof fetchConfig === "function" ? fetchConfig("javascript") : {
        method: "POST",
        headers: { Accept: "application/javascript" },
      };
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];

    const formData = new FormData();
    formData.append("line", line);
    formData.append("quantity", "0");
    formData.append("sections", getSectionIds().join(","));

    config.body = formData;

    const url = window.routes?.cart_change_url || "/cart/change";
    const response = await fetch(url, config);
    const data = await response.json();

    if (data.status === 422) return;

    document.querySelectorAll("cart-dynamic[data-section-id]").forEach((node) => {
      const htmlString = data.sections?.[node.dataset.sectionId];
      if (!htmlString) return;

      const html = new DOMParser().parseFromString(htmlString, "text/html");
      const fresh = html.querySelector(
        `cart-dynamic[data-section-id='${node.dataset.sectionId}']`
      );
      if (!fresh) return;

      node.innerHTML = fresh.innerHTML;
      node.className = fresh.className;
      node.dataset.cartItemCount = fresh.dataset.cartItemCount;
      node.dataset.cartTotal = fresh.dataset.cartTotal;
      node.dataset.freeShippingThreshold = fresh.dataset.freeShippingThreshold;
      if (typeof node.modified === "function") node.modified();
    });

    updateDrawerChrome();

    if (typeof triggerEvent === "function") {
      triggerEvent(document, "cart:update", {
        source: "cart-drawer",
        found: data.item_count > 0,
      });
    }
  }

  if (!customElements.get("cart-discount")) {
    customElements.define(
      "cart-discount",
      class CartDiscount extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector("[data-discount-form]");
          this.input = this.querySelector('input[name="discount"]');
          this.errorEl = this.querySelector("[data-discount-error]");

          if (!this.form || this._bound) return;
          this._bound = true;
          this.form.addEventListener("submit", this.onSubmit.bind(this));
        }

        showError(show) {
          this.errorEl?.classList.toggle("hidden", !show);
        }

        async discountApplied(code) {
          const cart = await fetch(
            `${window.routes?.cart_url || "/cart"}.js`
          ).then((r) => r.json());
          const normalized = code.toUpperCase();
          return (cart.cart_level_discount_applications || []).some((app) => {
            const title = (app.title || "").toUpperCase();
            return title === normalized || title.includes(normalized);
          });
        }

        async onSubmit(event) {
          event.preventDefault();
          this.showError(false);

          const code = this.input?.value?.trim();
          if (!code) return;

          const root = window.Shopify?.routes?.root || "/";
          try {
            await fetch(`${root}discount/${encodeURIComponent(code)}`, {
              method: "GET",
              credentials: "same-origin",
            });

            await refreshCartSections();

            const applied = await this.discountApplied(code);
            if (!applied) {
              this.showError(true);
              return;
            }

            this.showError(false);
            if (typeof triggerEvent === "function") {
              triggerEvent(document, "cart:update", { source: "cart-discount" });
            }
          } catch {
            this.showError(true);
          }
        }
      }
    );
  }

  document.addEventListener("click", (event) => {
    const removeBtn = event.target.closest("[data-cart-drawer-remove]");
    if (!removeBtn || !getDrawer()?.contains(removeBtn)) return;
    event.preventDefault();
    removeLineItem(removeBtn);
  });

  document.addEventListener("cart:update", () => {
    updateDrawerChrome();
  });
})();
